/** Only the approved external image files are used for Christmas decoration.
 * These components contain no CSS- or SVG-generated Christmas illustrations.
 * All decoration is noninteractive and excluded from accessibility reading.
 */
export function LoginChristmasDecor() {
  return <div className="login-christmas-background" aria-hidden="true">
    <img src="/assets/login/christmas/bg-natal-esquerda.jpg" alt="" draggable={false} />
  </div>
}

function Snowflake({ className = '' }: { className?: string }) {
  return <svg className={className} viewBox="0 0 40 40" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" aria-hidden="true">
    <path d="M20 2v36M2 20h36M7.3 7.3l25.4 25.4M32.7 7.3L7.3 32.7" />
    <path d="m15 6 5 5 5-5m-10 28 5-5 5 5M6 15l5 5-5 5m28-10-5 5 5 5M7 12l7 1-1-7m20 6-7 1 1-7M7 28l7-1-1 7m20-6-7-1 1 7" />
  </svg>
}

export function LoginChristmasPanelDecor() {
  return <>
    <div className="login-christmas-panel-flakes" aria-hidden="true">
      <Snowflake className="snowflake-a" />
      <Snowflake className="snowflake-b" />
      <Snowflake className="snowflake-c" />
    </div>
    <img className="login-christmas-corner" src="/assets/login/christmas/pinheiro-laco.png" alt="" aria-hidden="true" draggable={false} />
  </>
}

export function LoginChristmasHolly() {
  return <div className="login-christmas-divider" aria-hidden="true">
    <img src="/assets/login/christmas/azevinho.png" alt="" draggable={false} />
    <span className="login-christmas-divider-line" />
  </div>
}
